import { render, staticRenderFns } from "./user_charge.vue?vue&type=template&id=0af2ec0f&scoped=true"
import script from "./user_charge.vue?vue&type=script&lang=js"
export * from "./user_charge.vue?vue&type=script&lang=js"
import style0 from "./user_charge.vue?vue&type=style&index=0&id=0af2ec0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af2ec0f",
  null
  
)

export default component.exports